import { getCurrentEnvMode } from '@/utils/tools';
import { READ_NUM, AI_CONTENT_URL } from '@/config/config';
const env = getCurrentEnvMode();
// 接口域名与页面域名不同的接口配置
const diffHostApis = {
  dev: {
    operateConfig: '/eq/config_monitor_center/open/api/dynamic_configuration/v1/config_list',
    readNum: READ_NUM,
    aicontent: '/proxyDq/platform/aicontent/v1/query',
  },
  test: {
    operateConfig: '/open/api/dynamic_configuration/v1/config_list',
    readNum: READ_NUM,
    aicontent: AI_CONTENT_URL,
  },
  release: {
    operateConfig: '/open/api/dynamic_configuration/v1/config_list',
    readNum: READ_NUM,
    aicontent: AI_CONTENT_URL,
  },
};
const sameHostLink = '/content/report/research_report/v2/report/';
// 接口域名与页面域名相同的接口配置
const sameHostApis = {
  homeEmotion: `${sameHostLink}statics/by_rating/get`,
  orgRank: `${sameHostLink}rank/stock/org`,
  oldInterface: '/researchReport/index.php',
  homeRaiseSpace: `${sameHostLink}rank/stock/rising`,
  homeSingleRaiseSpace: `${sameHostLink}statics/stock/rising_space`,
  homeSingleStockPrice: `${sameHostLink}statics/stock/stock_price`,
  homeSingleAvgPrice: `${sameHostLink}statics/stock/ave_price`,
  homeGradeUpRank: `${sameHostLink}rank/stock/rate_up`,
  homeBuyRank: `${sameHostLink}rank/stock/rate_buy`,
  homeAnalystRank: `${sameHostLink}rank/stock/org`,
  allFollow: `${sameHostLink}follow/list/get`,
  homeGoldStock: `${sameHostLink}title/gold/get`,
  homeDailyReport: `${sameHostLink}title/week/get`,
  homeFirstCover: `${sameHostLink}title/cover/get`,
  homeStockPrice: `${sameHostLink}statics/stock/stock_price`,
  homeOneYearReport: `${sameHostLink}statics/stock/report_list`,
  homeScreenInfo: `${sameHostLink}content/filter/get`,
  followAuthor: `${sameHostLink}follow/author/get`,
  followOrg: `${sameHostLink}follow/org/get`,
  followIndustry: `${sameHostLink}follow/industry/get`,
  updateRead: `${sameHostLink}follow/user/read`,
  followReport: `${sameHostLink}title/follow/get`,
  getReport: `${sameHostLink}content/list/get`,
  homeTargetChart: `${sameHostLink}statics/stock/graph_table`,
  homeReportList: `${sameHostLink}content/list/get`,
  rankIndustryList: `${sameHostLink}rank/stock/industry`,
  iframeChangeList: `${sameHostLink}time_share/notify`,
  iframeForecastsList: `${sameHostLink}statics/stock/predict`,
  homePotentialHistory: `${sameHostLink}potential/history/get`,
  iframeOrgRating: `${sameHostLink}time_share/org_rating`,
  codeMap: `${sameHostLink}time_share/code_map`,
  rankNewWealth: `${sameHostLink}rank/stock/new_wealth_industry/list`,
  rankNewWealthDetail: `${sameHostLink}rank/stock/new_wealth`,
  rankSingle: `${sameHostLink}rank/stock/single`,
  rankAuthor: `${sameHostLink}rank/stock/author`,
  newWealthYear: `${sameHostLink}new_wealth/banner/year/get`,
  newWealthBanner: `${sameHostLink}new_wealth/banner/show/get`,
  newWealthSaw: `${sameHostLink}new_wealth/banner/click`,
  updateIsRead: `${sameHostLink}follow/user/read`,
  create: `${sameHostLink}mock/news/push`,
  homeCourseOperate: `${sameHostLink}yunying/grid/get`,
  klineCourseOperate: `${sameHostLink}yunying/time_share/get`,
  // K线分时 组合接口
  klineCombined: `${sameHostLink}time_share/combine/get`,
};
// 导出接口配置
export default {
  ...diffHostApis[env],
  ...sameHostApis,
};
